import { render, staticRenderFns } from "./wxshop.vue?vue&type=template&id=33a91046&scoped=true"
import script from "./wxshop.vue?vue&type=script&lang=js"
export * from "./wxshop.vue?vue&type=script&lang=js"
import style0 from "./wxshop.vue?vue&type=style&index=0&id=33a91046&prod&scoped=true&lang=scss"
import style1 from "./wxshop.vue?vue&type=style&index=1&id=33a91046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a91046",
  null
  
)

export default component.exports